import { StorageCapacityBanner } from 'rentalui-finance';
import { client } from '../api';
import { useAuth } from '../auth';

export default function UploadStorageAlert() {
  const { user } = useAuth();
  const enabled = user?.role === 'admin' || user?.roles?.includes('admin');
  return <StorageCapacityBanner client={client} enabled={!!enabled} />;
}
